import { Component, OnInit } from '@angular/core';
import { finalize, take } from 'rxjs/operators';
import { SeguroServices } from 'src/app/services/seguro/seguro.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { UtilService } from 'src/app/services/util.service';

@Component({
    selector: 'app-acompanhar-solicitacao',
    templateUrl: './acompanhar-solicitacao.component.html',
    styleUrls: ['./acompanhar-solicitacao.component.css'],
    imports: [CommonModule, DatePipe, CurrencyPipe, ReactiveFormsModule, FormsModule]
})
export class AcompanharSolicitacaoComponent implements OnInit {

  lista: any[] = [];

  constructor(private utilService: UtilService, private seguro: SeguroServices, private toastr: ToastrService) { }

  ngOnInit() {
    this.listar();
  }

  listar(){

    this.seguro
        .ListarSolicitacoes()
        .pipe(
          take(1)
        )
        .subscribe(
          (res) => {
            this.lista = res;
          }
        );
  }

  baixarProposta(codSolic: number, row: any){

    row.loading = true;

    this.seguro
        .BaixarArquivoProposta(codSolic)
        .pipe(
          finalize(()=> { row.loading = false })
        )
        .subscribe(
          (fileData) => {
            let nomeArquivo = `proposta_${codSolic}.pdf`;
            this.utilService.salvarArquivo(fileData, nomeArquivo);
          },
          (error: HttpErrorResponse) => {
            this.toastr.error(error.error.ex);
          }
        )
  }

}
